export default __webpack_public_path__ + "static/media/arrow-left.3cd7355f.svg";